export const isEmptyString = (value?: string | null, trim?: boolean) =>
    value == null || (trim ? value.trim() === "" : value === "");

// For type predicate
export const isNotEmptyString = (
    value?: string | null,
    trim?: boolean
): value is string => !isEmptyString(value, trim);

/**
 * Checks if a list is not empty. Acts as a type predicate to narrow the type.
 * @param value - The array to check
 * @param ignoreEmptyItem - If true, filters out null/undefined items before checking length
 * @returns true if the list has items (excluding null/undefined if ignoreEmptyItem is true)
 */
export const isNotEmptyList = <T>(
    value?: T[] | readonly T[],
    ignoreEmptyItem = true
): value is T[] | readonly T[] => !isEmptyList(value, ignoreEmptyItem);

/**
 * Checks if a list is empty or contains only null/undefined items.
 * @param value - The array to check
 * @param ignoreEmptyItem - If true, filters out null/undefined items before checking length
 * @returns true if the list is null, undefined, or has no valid items
 */
export const isEmptyList = <T>(
    value?: T[] | readonly T[],
    ignoreEmptyItem = true
) =>
    value == null ||
    value.filter((v) => (ignoreEmptyItem ? v != null : true)).length === 0;
